import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  TabActionDialog
} from "@saleor/types";
import { stringify as stringifyQs } from "qs";

export const remittancePath = "/remittance";

export enum RemittanceListUrlFiltersEnum {
  query = "query",
  orderDateFrom = "orderDateFrom",
  orderDateTo = "orderDateTo",
  orderCompleteDateFrom = "orderCompleteDateFrom",
  orderCompleteDateTo = "orderCompleteDateTo",
  orderDate = "orderDate"
}
export const remittanceListUrl = (params?: RemittanceListQueryParams) =>
  remittancePath + "?" + stringifyQs(params);

export type RemittanceListUrlDialog = "download" | TabActionDialog;

export type RemittanceListUrlFilters = Filters<RemittanceListUrlFiltersEnum>;

export type RemittanceListQueryParams = ActiveTab &
  RemittanceListUrlFilters &
  BulkAction &
  Dialog<RemittanceListUrlDialog> &
  Pagination &
  SingleAction;
